import angular from 'angular';
import constants from 'app/constants';
import {
  amDataService,
  amSharedModelService,
  docDataService,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
} from 'app/services';
import {
  alerts,
  confirmDialog,
} from 'app/components/global';
import attachFindingDialog from '../dialog.saveFindingConfirmDialog/attachFindingDialog';
import editFindingCommentDialog from '../dialog.editFindingCommentDialog';
import editFindingDialog from '../dialog.editFindingDialog';
import controller from './finding.controller';
import directive from './finding.directive';
import findingComment from '../findingComment';
import findingDocument from '../findingDocument';
import findingReport from '../findingReport';


export default angular.module('app.components.advisory.auditTrail.finding', [
  alerts,
  amDataService,
  amSharedModelService,
  attachFindingDialog,
  confirmDialog,
  constants,
  docDataService,
  editFindingCommentDialog,
  editFindingDialog,
  findingComment,
  findingDocument,
  findingReport,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
])
  .directive('amFinding', directive)
  .controller('FindingController', controller)
  .name;

console.log('app.components.advisory.auditTrail.finding created');
